<template>
  <div>
    <div class="comments-title-div">
      <div class="d-flex mb-3 justify-space-between">
        <div class="comment-title">Comments</div>
        <div>
          <v-icon @click="closeComment" color="">mdi-chevron-up </v-icon>
        </div>
      </div>
      <v-form class="actions" ref="entryForm" @submit.prevent="addComment">
        <div class="d-flex justify-center align-center">
          <v-textarea
            placeholder="Write your comment here "
            height="55"
            :rules="rules"
            v-model="commentText"
            outlined
            required
            class="text__field"
          ></v-textarea>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              style="border-radius: 5px"
              height=""
              type="submit"
              color="#2D8CFF"
              id="first-comment"
              class="px-2 save__btn"
              >Add</v-btn
            >
          </div>
        </div>
      </v-form>
    </div>
    <div v-if="isComment || comments.length > 0" class="comment-container">
      <CommentCard
        :trade_detail="trade_detail_form"
        :comment="comments"
        :item="item"
        v-for="item in comments"
        :key="item.id"
      />
    </div>
    <!-- <div style="height: 20px; background: #f7faff"></div> -->
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
// import apiUrl from "@/common/apiUrl";
import CommentCard from "@/components/Trade/CommentCard.vue";
import { isAuthenticated } from "@/common/commonFunctions";
import commonFunctions from "@/common/commonFunctions";

export default {
  components: {
    CommentCard,
  },
  props: ["trade_detail_form", "isFOTrade"],
  data() {
    return {
      commentText: null,
      comments: [],
      rules: [],
      loading: false,
      isComment: false,
    };
  },
  mounted() {
    this.getTradeDetails();
  },

  computed: {
    getTradeURL() {
      return this.isFOTrade ? "get-fno-trade" : "user-trade-detail";
    },
    getCommnetURl() {
      return this.isFOTrade ? "add_fno_comment" : "update-comment";
    },
  },
  methods: {
    closeComment() {
      this.$emit("close-comment", null);
    },

    addComment() {
      console.log("add comment ");
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to add comment here",
          color: "success",
          timeout: 4500,
        });

        return false;
      }
      this.rules = [(v) => !!v || "Field is required"];
      console.log(this.$refs.entryForm.validate());
      if (this.commentText) {
        const user_id = localStorage.getItem("profile_id");
        const data = {
          comment: this.commentText,
          user_id: user_id,
        };
        const successHandler = (res) => {
          console.log(res.data.message);
          this.commentText = null;
          this.comments = res.data;
          this.isComment = true;

          // this.loading = true;
          //   this.getTradeDetails();
          this.scrollToComment();
          this.$emit("count-comment", this.comments.length);

          setTimeout(() => {
            this.$emit("reload-trade-data-comment", this.trade_detail_form.id);
            this.$emit("reload-home-trade");
          }, 500);
        };
        const errorHandler = (err) => {
          console.log(err);
        };
        Axios.request_POST(
          `api/trade/${this.getCommnetURl}/${this.trade_detail_form.id}/`,
          data,
          {},
          successHandler,
          errorHandler,
          false,
          false
        );
        this.rules = [];
      }
    },
    getTradeDetails() {
      const successHandler = (res) => {
        this.trade_data = res.data;
        // if(this.isFOTrade)
        this.comments = this.isFOTrade
          ? this.trade_data.data.comments
          : this.trade_data.comments;
        console.log(this.trade_data);
        // if (this.trade_data.is_real) {
        //   this.getActions();
        // }

        setTimeout(() => {
          this.loading = false;
        }, 500);
      };
      const errorHandler = (err) => {
        console.log(err);
        this.loading = false;
      };
      Axios.request_GET(
        `api/trade/${this.getTradeURL}/${this.trade_detail_form.id}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        commonFunctions.IsAuth()
      );
    },
    scrollToComment() {
      document.getElementById("first-comment").scrollIntoView();
    },
  },
};
</script>

<style lang="scss" scoped>
.comments-title-div {
  padding: 10px 20px;
  padding-bottom: 15px;
  background: #f6f7fa;
}

.comment-title {
  font-weight: 900;
  font-size: 17px;
}
.comment-container {
  max-height: 400px;
  overflow-x: scroll;
  padding: 20px 20px;
  padding-bottom: 0;
}
.actions {
  // display: flex;
  background: #f6f7fa;
}

.text__field {
  border-radius: 5px;
  background: #fff;
  height: 55px;
  width: 70%;
  border: 1px solid #f2f2f2;
}

.save__btn {
  text-transform: capitalize;
  color: #fff;
  letter-spacing: 0px;
  border-radius: 8px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  width: 120px;
  // font-size: 16px;
  // font-weight: 800;
}
@media all and (max-width: 600px) {
  .comment-container,
  .comments-title-div {
    padding: 10px 14px !important;
    padding-bottom: 0;
  }
  .title-span {
    font-size: 16px;
  }
  .comment-title {
    font-size: 16px;
  }
  .trade-time,
  .user-name {
    font-size: 14px;
  }
  .price-span {
    font-size: 12px;
  }
  .caption {
    font-size: 15px !important;
  }
  .text__field {
    width: 100% !important;
  }
  ::v-deep.text__field {
    height: 40px !important;
  }
  .actions {
    padding-bottom: 10px !important;
  }
  .save__btn {
    width: 10px !important;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
  }
  ::v-deep.v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    // align-items: stretch;
    min-height: 40px !important;
  }
  ::v-deep.v-text-field--outlined fieldset {
    height: 43px !important;
  }
  ::v-deep.v-textarea textarea {
    margin-top: 10px !important;
    font-size: 12px !important;
    line-height: 3ch !important;
    min-height: 23px !important;
  }
  ::v-deep.v-text-field
    > .v-input__control
    > .v-input__slot
    > .v-text-field__slot {
    height: 36px !important;
  }
  .save__btn {
    // margin-top: 5px !important;
    height: 30px !important;
  }
}
</style>
